module.exports = __webpack_public_path__ + "img/dstv-change-package-2.e36ef983.jpg";